import type { FaireProductEntity } from "../../entity_types/product";

export const p_7uowp8m3yn: FaireProductEntity = {
  token: "p_7uowp8m3yn",
  type: "product",
  name: "Soothing Salve — fragrance free and gentle for all ages",
  brandToken: "b_8tnoit8j85",
  brandName: "Mickelberry Gardens",
  imageUrl:
    "https://cdn.faire.com/fastly/e0addcc5fd2ef2d2448be88a4012554a219fdabc4c80376661e5ee67ae1b044d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a01da52f055d22ab34949016a9d243f6facf3b998cf1c70c9b9cdc93252387a.jpeg",
    "https://cdn.faire.com/fastly/1f8e58214547a854fa4334f084a8783ee1fc72299bdc5bb59d7b13e0ea791431.jpeg",
    "https://cdn.faire.com/fastly/9b579fffa823edaf5e7bb3aa15e5845f2b44f4db81c94fce9988110dc8500903.jpeg",
    "https://cdn.faire.com/fastly/e10c722a49f062f659df4a3779112935f4bef09599dc76dd5e7714e443305be8.jpeg",
    "https://cdn.faire.com/fastly/ffb4b450b32e389ac94d3c4d30d2f6e38670ebab40aa34753bb98415b49633de.jpeg",
    "https://cdn.faire.com/fastly/e20580f42469c4830e426435759382f2889f4b3ba2acfd287cb6dbfefa22281b.jpeg",
  ],
  priceDollars: 11.78,
  description:
    "Mickelberry Gardens Soothing Salve utilizes seven soothing, organic herbs infused into olive oil to deliver their healing powers to your skin. It is made with treatment-free Pacific Northwest beeswax, along with skin nourishing domestic olive oil and fair-trade Shea butter. It contains no added fragrance and is very gentle.\n\nAvailable in a 2 oz. glass jar.\n\n• 100% botanical ingredients\n• Clean, natural and effective\n• Non-greasy and free of added fragrances\n• Safe for all ages\n• Locally sourced\n• Sustainably harvested\n• Bee friendly\n\nPerfect for anyone who suffers from eczema, skin abrasions, or chronic itchy skin. Apply to dry skin, cracked skin, cuts and scrapes, blisters, rashes, burns, bruises, and itchy bug bites. It works well as an all-natural hair and nail treatment and is safe for all ages.\n\nAll of the items in our skincare line are made with locally-sourced beeswax from honey cappings. We render our beeswax in-house. It naturally smells amazing, and is an emollient that helps to soothe and protect the skin.\n\nWe source ingredients fresh, directly from Pacific Northwest growers and producers. We make all our products with strict attention to quality. Our facility is certified GMP-compliant, and is free of all major allergens, including gluten.",
  tags: [],
  msrpDollars: 23.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:42.239Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
